import React from 'react';
import { List } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import FormattedHTMLMessage from '@/components/FormattedHTMLMessage';
import { resolveRequestWorkflow } from '../state/state';

const RequesterListItem = ({ name, email }) => (
  <List.Item className="aridhia-request-applicant-email-list-item">
    <List.Header>
      <FormattedMessage id="request.list.requested.by.title" />
    </List.Header>
    <List.Description className="aridhia-form-item-description">
      <FormattedHTMLMessage id="request.list.requested.by" values={{ email, name }} />
    </List.Description>
  </List.Item>
);

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps, { requester: { name: '', email: '' } });

  return (
    {
      name: request.requester?.name,
      email: request.requester?.email,
    }
  );
};

export default connect(mapStateToProps)(RequesterListItem);
